

export default {
  //SET_MY_SCHEDULE: (state, data) => {
  //  state.MySchedule = data;
  //}


}



// WEBPACK FOOTER //
// ./VueSrc/Common/Store/Education/MySchedule_mutations.js